import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { sanitizeInput } from "../utils/utils";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const sanitizedUsername = sanitizeInput(username.trim());
    const sanitizedPassword = sanitizeInput(password.trim());

    if (!sanitizedUsername || !sanitizedPassword) {
      setError("Username and password are required.");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username: sanitizedUsername, password: sanitizedPassword }),
      });
      if (!response.ok) {
        setError("Wrong credentials or server issue.");
        return;
      }

      const result = await response.json();
      if (result.token) {
        console.log("Response from API:", result);
        localStorage.setItem('userToken', result.token);
        if (result.game_id) {
          localStorage.setItem('gameId', result.game_id);
          localStorage.setItem('gameName', result.gameName);
        }
      }
      else {
        setError("Wrong credentials!");
      }

      navigate("/");

    } catch (error) {
      setError("Server error")
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full h-screen flex flex-col items-center justify-center bg-gradient-to-b from-[#083c99] to-[#081a55] p-6">
      <div className="flex flex-col  bg-[#083c5d] p-8 rounded-lg shadow-lg w-full max-w-sm">
        <img src="/logo.png" alt="logo" className="w-128 " />

        {error && <p className="text-red-500 mb-4">{error}</p>}

        <label htmlFor="username" className="text-lg font-semibold wtext mb-2 text-left">Mono ime:</label>
        <input
          type="text"
          value={username}
          onChange={(e) => { setUsername(e.target.value); setError(null) }}
          placeholder="vnesi mono ime"
          className="w-full px-4 py-2 mb-4 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />

        <label htmlFor="password" className="text-lg font-semibold wtext mb-2">Geslo:</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="vnesi geslo"
          className="w-full px-4 py-2 mb-4 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />

        <button type="submit" className="w-full py-3 rounded-lg shadow-md transition duration-300">PRIJAVA</button>
      </div>
    </form>
  );
};

export default Login;
